import { flatten, get, isFunction } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';

import SingleTabNav from './SingleTabNav';
import {
  ProfileTabContainerStyled,
  TabContainerStyled,
  TabContentOuterContainerStyled,
  TabNavigationContainerStyled,
} from './styled';
import TabContent from './TabContent';
import { ITabProps } from './types';

const Tab: React.FC<ITabProps> = ({
  children,
  defaultActiveKey,
  activeKey,
  onTabClick,
  className,
  mobileThreshold,
  displayMenuInMobile,
  onContentClick,
}) => {
  const defaultFirstActiveKey = useMemo(() => {
    if (activeKey !== undefined) {
      return activeKey;
    }
    if (defaultActiveKey !== undefined) {
      return defaultActiveKey;
    }
    return children[0].key || undefined;
  }, []);
  const [currentActiveKey, setActiveKey] = useState(defaultFirstActiveKey);

  useEffect(() => {
    if (activeKey !== undefined) setActiveKey(activeKey);
  }, [activeKey]);

  const [tabNavComponents, setTabNavComponents] = useState<any[]>([]);
  const [tabContentComponents, setTabContentComponents] = useState<any[]>([]);
  const childrenComponent = useMemo(() => flatten(children), [children]);

  const onTabClickDefault = (key: string | number, index: number) => {
    if (onTabClick) onTabClick(key, index);
    setActiveKey(key);
  };

  useEffect(() => {
    const tempNavBarComps: any[] = [];
    const tempContentComps: any[] = [];
    childrenComponent.forEach((component: any, index: number) => {
      tempNavBarComps[index] = (
        <SingleTabNav
          key={component.key}
          active={component.key === currentActiveKey}
          compKey={component.key}
          onClick={onTabClickDefault}
          disabled={get(component, 'props.disabled')}>
          {get(component, 'props.tab') || null}
        </SingleTabNav>
      );
      tempContentComps[index] = (
        <TabContent
          key={component.key}
          active={component.key === currentActiveKey}
          className={`custom-tabs-content-${component.key}`}>
          {isFunction(component.props.children) ? component.props.children(currentActiveKey, component.key) : component}
        </TabContent>
      );
    });
    setTabNavComponents(tempNavBarComps);
    setTabContentComponents(tempContentComps);
  }, [children, currentActiveKey, activeKey, defaultActiveKey]);

  return (
    <ProfileTabContainerStyled
      className={className}
      $mobileThreshold={mobileThreshold}
      $displayMenu={displayMenuInMobile}>
      <TabContainerStyled className='gx-p-0 custom-tabs-container gx-m-0'>
        <TabNavigationContainerStyled className='custom-tabs-nav-bar gx-px-0'>
          {tabNavComponents}
        </TabNavigationContainerStyled>
        <TabContentOuterContainerStyled onClick={onContentClick} className='custom-tabs-tab-content-container'>
          {tabContentComponents}
        </TabContentOuterContainerStyled>
      </TabContainerStyled>
    </ProfileTabContainerStyled>
  );
};

export default Tab;
